export default {
	data() {
		return {
			apiAbortController: null
		}
	},
	beforeDestroy() {
		if (this.apiAbortController) {
			this.apiAbortController.abort()
		}
	},
	methods: {
		/**
		 *
		 * @returns {AbortSignal}
		 */
		getAbortSignal() {
			if (this.apiAbortController === null) {
				this.apiAbortController = new AbortController();
			}
			return this.apiAbortController.signal
		},
		/**
		 *
		 * @param error
		 *        401 Authorization required.
		 *        403 Access denied.
		 *
		 * @param ok
		 */
		apiErrorHandler(error, ok = "OK") {
			switch (error.code) {
				case 401:
					// case 403:
					this.cdvAlert(this._(error.en), '', null, ok).then(() => {}).catch(() => {});
					
					this.$store.commit('Api/setAuthToken', null);
					this.$store.commit('Api/setAuthTokenData', null);
					
					if (!this.$router.currentRoute.path.match(/(enroll)|(reset_password)|(login)|(config)/gi)) {
						this.$router.push('/', () => null, () => null)
					}
					
					break;
				case 900:
					console.error(error)
					break;
				default:
					console.error(error)
					this.cdvAlert(this._(error.en), undefined, null, ok).then(() => {}).catch(() => {});
			}
		}
	}
}
